// extracted by mini-css-extract-plugin
module.exports = {"tarifContainer":"tarif_tarifContainer__2rMPe","tarifItems":"tarif_tarifItems__2j5YW","tarifItem":"tarif_tarifItem__2zzSj","card":"tarif_card__21fir"};